import { targetBlank } from '../utils';

export default function customTicketButton() {
  const widgetName = 'hotButtonsWidget';
  const widgetOpts = hotButtonsWidgetOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 4,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomTicketBtn(data.items);
      } else {
        $widget.remove();
      }
    },
  });

  function createCustomTicketBtn(widgetData) {
    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];
      const $cardItem = $(this);

      if (URL == null) {
        $cardItem.remove();
      } else {
        const targetElement = targetBlank(URL);
        $cardItem.replaceWith(
          `<a class="hot-button" tabindex="0" href="${URL}" ${targetElement}>${Title}</a>`,
        );
      }
    });
  }
}
